import React, { useContext, useEffect, useState } from "react";
import { IonActionSheet } from "@ionic/react";

/* Global State*/ 

import { useHistory } from "react-router-dom";
import c from "../utils/common";
import { useTranslation } from "react-i18next";
import useGeneralStore from "../states/useGeneral";

let globalState = undefined;

const Config = (props) => {
  const history = useHistory();
  
  const { t, i18n } = useTranslation();

  const { language, languageSelector, changeLanguage, toggleLanguageSelector } = useGeneralStore();

  const _changeLanguage = () => {
    if (language == null) {
      // init global state
      console.log("init language to global state: " + i18n.language);
      changeLanguage(i18n.language);
    } else {
      console.log("change language to: " + language);
      i18n.changeLanguage(language);
    }
  };

  useEffect(() => {
    _changeLanguage();
  }, [language]);

  return (
    <div>
      <IonActionSheet
        mode="ios"
        isOpen={languageSelector?.isShow}
        onDidDismiss={() => {
          toggleLanguageSelector(false);
        }}
        buttons={[
          {
            text: "中文",
            handler: () => {
              console.log("中文 clicked");
              changeLanguage("chn");
            },
          },
          {
            text: "English",
            handler: () => {
              console.log("English clicked");
              changeLanguage("en");
            },
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              console.log("Cancel clicked");
            },
          },
        ]}
      ></IonActionSheet>
    </div>
  );
};

export default Config;
